import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { UnitProgress, CourseProgressSummary } from '../data/student-report';
import { Course } from '../data/course';
import { StudentSpeakingScore, UnitSparcScore } from '../data/speaking-score';
import Chart from 'chart.js/auto';
import { WidaPredictionDetails, WidaPredictionErrorCodes } from '../data/wida-prediction';
import { StudentDomainScore } from '../data/student-domain-scores';

@Component({
  selector: 'app-student-progress-report',
  templateUrl: './student-progress-report.component.html',
  styleUrls: ['./student-progress-report.component.scss']
})

export class StudentProgressReportComponent extends BaseComponent implements OnInit {

  @Input() studentId: number;
  @Input() defaultCourseCode: string;
  @Input() organizationId: number;

  courseProgressSummaries: CourseProgressSummary[];
  unitProgress: UnitProgress;
  currentCourse: CourseProgressSummary;
  get loaded(): boolean {
    return this.loadedCount >= 6;
  }

  loadedCount: number = 0;
  highestCourseWithProgress: CourseProgressSummary;
  lowerCourseSelected: boolean;

  speakingScore: StudentSpeakingScore;
  speakingScoreHistory: UnitSparcScore[];

  widaPredictionDetails: WidaPredictionDetails;

  courses: Course[];

  domainScores: StudentDomainScore[];

  get selectableCourses(): CourseProgressSummary[] {
    return this.courseProgressSummaries?.filter(course => !course.CourseCode.startsWith('P-'));
  }

  ngOnInit() {
    this.getStudentCourseProgress(this.studentId); // this function calls loadedCount++ internally
    this.dataService.getCourses().subscribe(c => { this.courses = c; this.loadedCount++; });
    this.dataService.getStudentSpeakingScores(this.studentId).subscribe(s => { this.getLatestSpeakingScore(s); this.loadedCount++; });
    this.dataService.getStudentSpeakingScoreHistory(this.studentId).subscribe(s => { this.getStudentSpeakingScoreHistory(s); this.loadedCount++; });
    this.dataService.getStudentWidaPredictions(this.studentId, this.organizationId).subscribe(r => { this.showWida(r); this.loadedCount++; });

    var domainReportStart = new Date();
    domainReportStart.setMonth(domainReportStart.getMonth()-2);
    this.dataService.getStudentDomainScores(this.studentId, domainReportStart, null).subscribe(s => { this.domainScores = s; this.loadedCount++; });
  }

  showWida(widaPredictionDetails: WidaPredictionDetails) {
    this.widaPredictionDetails = widaPredictionDetails;
  }

  getLatestSpeakingScore(scores: StudentSpeakingScore[]): void {
    if (!scores || !scores.length) return;

    scores = scores.sort((a, b) => a.CalculationDate.valueOf() - b.CalculationDate.valueOf());
    this.speakingScore = scores.pop();
  }

  getStudentSpeakingScoreHistory(scores: UnitSparcScore[]): void { // TODO: do we need to wait until getLatestSpeakingScore has been called?
    this.speakingScoreHistory = scores;
  }

  getStudentCourseProgress(studentId: number): void {
    this.dataService.getStudentProgressSummaryAllCourses(studentId).subscribe(r => {
      this.courseProgressSummaries = r.filter(course => course.CourseCode != "DaisyChain");
      this.courseProgressSummaries = this.sortCourses(this.courseProgressSummaries);
      var coursesWithProgress = this.courseProgressSummaries.filter(x => x.TimeSpent > 0);
      this.highestCourseWithProgress = coursesWithProgress && coursesWithProgress.length > 0 ? coursesWithProgress[coursesWithProgress.length - 1] : this.courseProgressSummaries[0];
      this.selectCourse(this.defaultCourseCode);
      this.loadedCount++;
    });
  }

  selectCourse(courseCode: string): void {
    var currentCourseIndex = this.courseProgressSummaries.findIndex(x => x.CourseCode === courseCode);
    this.lowerCourseSelected = currentCourseIndex < this.courseProgressSummaries.indexOf(this.highestCourseWithProgress);
    this.currentCourse = this.courseProgressSummaries[currentCourseIndex];
  }

  sortCourses(courses: CourseProgressSummary[]): CourseProgressSummary[] {
    return courses.sort((a, b) => {
      let aCourse = this.courses.find(c => c.Code == a.CourseCode);
      let aIndex = aCourse ? aCourse.NumberOnly : -1;

      let bCourse = this.courses.find(c => c.Code == b.CourseCode);
      let bIndex = bCourse ? bCourse.NumberOnly : -1;
      return aIndex - bIndex;
    });
  }

  isKinder() : boolean {
    return !this.isPathways();
  }

  isPathways(): boolean {
    return this.currentCourse && (this.currentCourse.CourseCode.startsWith("Pathways") || this.currentCourse.CourseCode.startsWith("P-"));
  }
}
